import { GenericErrorIcon } from './GenericErrorIcon';
import React from 'react';
import { ErrorScreenProps, ErrorType } from '../schema/ErrorScreen.types';
import { BaseErrorScreen } from './BaseErrorScreen';

const styles = require('./ErrorScreen.scss');
const classNames = require('classnames/bind').bind(styles);

/**
 * Functional Component to display the Generic Error Screen
 * @param props Error Screen Props
 */
export const GenericErrorScreen = (props: ErrorScreenProps): JSX.Element => (
    <div
        className={classNames(
            styles.errorScreenContainer,
            props?.screenConfig?.isFullScreen && styles.fullScreenErrorContainer
        )}>
        <div className={styles.iconContainer}>
            <GenericErrorIcon />
        </div>
        <BaseErrorScreen {...props} errorType={ErrorType.Generic} />
    </div>
);
